// Formata data como HH:MM para exibição
const formatHourDisplay = hour => {
	let newhour = hour.split(":")
	return newhour[0] + ":" + (newhour[1] ? newhour[1]: "00" )
}

export default formatHourDisplay;